import React, { useCallback } from 'react';
import { isSafari } from 'react-device-detect';
import { useSelector } from 'react-redux';

import { joinClassNames, STORY_CONFIG_ID } from '../../../util/util';

interface SVGWrapperProps {
	settings?: any;
	id?: string;
	noMouseEvent?: boolean;
	isMobile?: boolean;
	className?: string;
	showVerticalViewBox?: boolean;
	style?: any;
	children?: React.ReactNode;
	queryParams?: any;
	onMouseLeave?: (_event: React.MouseEvent) => void;
	onMouseMove?: (_event: React.MouseEvent) => void;
	onTouchStart?: (_event: React.TouchEvent) => void;
	onTouchEnd?: (_event: React.TouchEvent) => void;
	onTouchMove?: (_event: React.TouchEvent) => void;
	onKeyDown?: (_event: React.KeyboardEvent) => void;
	onKeyUp?: (_event: React.KeyboardEvent) => void;
	htmlRef?: React.Ref<SVGSVGElement>;
	isIFrameWidgetAvailable?: boolean;
}

const baseClassName = 'interactOverlayContainer';

const SVGWrapper = ({
	noMouseEvent = true,
	className,
	id,
	showVerticalViewBox,
	style,
	children,
	isMobile,
	onMouseLeave,
	onMouseMove,
	onTouchStart,
	onTouchEnd,
	onTouchMove,
	queryParams,
	isIFrameWidgetAvailable = false,
}: SVGWrapperProps) => {
	const { isPlaying } = useSelector((state) => (state as any).playerReducer);
	const { currentMediaId, playlistId, mediaType } = useSelector((state) => (state as any).configurationReducer);
	const currentPlayerId = `player-${playlistId || currentMediaId}`;

	const handleButtonPlay = useCallback(() => {
		(window as any).GoBrain.widgets(currentPlayerId)?.play?.();
	}, [currentPlayerId]);

	const handleButtonPause = useCallback(() => {
		(window as any).GoBrain.widgets(currentPlayerId)?.pause?.();
	}, [currentPlayerId]);
	const isStoryPlayer = typeof queryParams?.configId === "string" && queryParams.configId.toLowerCase().includes(STORY_CONFIG_ID.toLowerCase());

	return (
		<>
			{(isMobile || isSafari) && (isIFrameWidgetAvailable || isStoryPlayer) && (
				<div
					onClick={mediaType !== 'scenario' && isStoryPlayer ? (isPlaying ? handleButtonPause : handleButtonPlay) : undefined}
					id="iframeWidgetsLayer"
					style={{
						position: 'relative',
						height: '100%',
						width: '100%',
						backgroundColor: 'transparent',
						zIndex: 10001,
						pointerEvents: 'none',
					}}
				/>
			)}
			<svg
				className={joinClassNames(['mainSVG', baseClassName, noMouseEvent ? `${baseClassName}--noMouseEvent` : '', className])}
				id={id ?? 'mainSVG'}
				width="100%"
				height="100%"
				viewBox={showVerticalViewBox ? '547 0 506 900' : '0 0 1600 900'}
				style={style}
				onMouseLeave={isMobile ? undefined : onMouseLeave}
				onMouseMove={isMobile ? undefined : onMouseMove}
				onTouchStart={onTouchStart}
				onTouchMove={onTouchMove}
				onTouchEnd={onTouchEnd}
			>
				{children}
				<use xlinkHref="https://play2.qbrick.com/custom/modules/interactiveoverlay/defaultScriptV3.js" />
			</svg>
		</>
	);
};

export default SVGWrapper;
